<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd sub-page-padding-right">
            <Form ref="form" :model="formData" :rules="rule" :label-width="130">
                <FormItem :label="$t('logo_img_lnk')" prop="img_lnk">
                    <myCropImg :autoCropWidthHeight="[300,300]" crop_height="350px" crop_width="350px" :original_url="formData.img_lnk" @cropImgUpload="setOrgIcon"></myCropImg>
                </FormItem>
                <FormItem :label="$t('build_img_lnk')" prop="img_lnk">
                    <myCropImg :autoCropWidthHeight="autoCropWidthHeight" :original_url="formData.build_img_lnk" @cropImgUpload="setOrgBuildImg"></myCropImg>
                </FormItem>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('code')" prop="org_code">
                            <Input v-model="formData.org_code" disabled></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('org_cname')" prop="org_cname">
                            <Input v-model="formData.org_cname" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                </Row>
<!--                <Row v-if="formData.org_level == '3'">-->
<!--                    <Col span="12">-->
<!--                        <FormItem :label="$t('org_grade')" prop="org_level">-->
<!--                            <Input v-model="formData.org_grade_cdesc" disabled></Input>-->
<!--                        </FormItem>-->
<!--                    </Col>-->
<!--                </Row>-->
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('org_cid')" prop="org_cid" >
                            <Input v-model="formData.org_cid" disabled></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('org_cor')" prop="org_cor" >
                            <Input v-model="formData.org_cor" disabled></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('org_contact')" prop="org_mobile">
                            <Input v-model="formData.link_cname" disabled></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('org_mobile')" prop="org_mobile">
                            <Input v-model="formData.link_mobile" disabled></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('cu_cname')" prop="cu_cname">
                            <Input v-model="formData.cu_cname" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('cu_mobile')" prop="cu_mobile">
                            <Input v-model="formData.cu_mobile" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('cu_ser_time')" prop="cu_time_area">
                            <Input v-model="formData.cu_time_area" :placeholder="$t('cu_start_time')"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('recv_cor_cname')" prop="recv_cname">
                            <Input v-model="formData.recv_cname" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('phone')" prop="recv_mobile">
                            <Input v-model="formData.recv_mobile" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <!--省市区选择-->
                <FormItem :label="$t('addrvalue')" prop="addrLabel">
                    <Cascader :data="addrData" trigger="click" :filterable="true" v-model="formData.addrLabel"  @on-change = "addrValueChang"></Cascader>
                </FormItem>
                <!--详细地址-->
                <FormItem :label="$t('org_addr')" prop="org_addr">
                    <Input v-model="formData.org_addr"></Input>
                </FormItem>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('org_admin_code')" prop="org_admin_code" >
                            <Input v-model="formData.org_admin_code" disabled></Input>
                        </FormItem>
                    </Col>
                </Row>
                <FormItem :label="$t('cdesc')" prop="func_cdecs" >
                    <Input v-model="formData.func_cdecs" type="textarea" :autosize="{minRows: 2,maxRows: 3}"></Input>
                </FormItem>
                <Row>
                    <Col span="12"><FormItem :label="$t('add_user')"><Input v-model="formData.add_user" disabled></Input></FormItem></Col>
                    <Col span="12"><FormItem :label="$t('add_time')"><Input v-model="formData.add_time" disabled></Input></FormItem></Col>
                </Row>
                <Row>
                    <Col span="12"><FormItem :label="$t('upd_user')"><Input v-model="formData.upd_user" disabled></Input></FormItem></Col>
                    <Col span="12"><FormItem :label="$t('upd_time')"><Input v-model="formData.upd_time" disabled></Input></FormItem></Col>
                </Row>
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="submit">{{$t('save')}}</Button>
        </div>
    </div>
</template>

<script>
    import myCropImg from '../../../components/myCropImg.vue'
    import addr from '../../../utils/addr/index'
    export default {
        components: {
            myCropImg,
        },
        data:function(){
            return{
                autoCropWidthHeight:[450,270],
                relist:false,
                formData: {
                    org_cname: "",
                    org_admin_code: "",
                    cu_cname: "",
                    cu_mobile: "",
                    img_lnk: "",
                    build_img_lnk: "",
                    org_cdesc: "",
                    org_cid: "",
                    org_code: "",
                    org_cor: "",
                    org_id: "",
                    org_level: "",
                    org_mobile: "",
                    cid_img_lnk: "",
                    org_prov: "",
                    org_city: "",
                    org_area: "",
                    org_addr: "",
                    org_addr_code: "",
                    addrLabel: [],
                    link_cname: '',
                    link_mobile: '',
                    cu_time_area: '',
                    recv_cname: "",
                    recv_mobile: "",
                    add_user:'',
                    add_time:'',
                    upd_user:'',
                    upd_time:'',
                },
                addrData: [],
                rule: {
                    // img_lnk: [{validator: this.validateIcon,trigger: 'change'}],
                    org_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    cu_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    cu_mobile: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    cu_time_area: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    org_admin_code: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    addrLabel: [{required: true, message: this.$t('input'), trigger: 'change', type:'array'}],
                    org_addr: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                }
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.formData.func_id = this.$base.getRequest().id;
            this.getInfo();
            setTimeout(() => {
                this.addrData = addr.getAddrData()
            }, 500)
        },
        methods:{
            // validateIcon: function (rule, value, callback) {
            //     if(!this.formData.img_lnk){
            //         callback(this.$t('please_upload_icon_tip'))
            //     }
            //     else{
            //         callback();
            //     }
            // },
            setOrgIcon: function (file_path) {
                this.formData.img_lnk = file_path;
            },
            setOrgBuildImg: function (file_path) {
                this.formData.build_img_lnk = file_path;
            },
            cancel: function(){
                this.$base.linkBack();
            },

            getInfo: function(){
                var id = this.$base.getRequest().id;
                var data = {

                };
                this.$base.showLoading();
                this.$request.sendPost("org/info",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.formData = this.$base.leftJson(this.formData,data);
                        /*mounted之后getInfo获得图片地址,通过watch得到更新的图片地址*/
                        //this.formData.addrLabel.push(this.formData.org_prov,this.formData.org_city,this.formData.org_area);
                        this.formData.addrLabel=this.formData.org_addr_code.split(',');
                        //console.log(this.formData.addrLabel=['jiangsu', 'suzhou', 'zhuozhengyuan']);
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            addrValueChang(value,selectedData){
                this.formData.org_addr_code = value.toString();

                this.formData.org_prov = selectedData[0].label;
                if(selectedData.length == 3){
                    this.formData.org_city = selectedData[1].label;
                    this.formData.org_area = selectedData[2].label;
                }
                else if(selectedData.length == 2) {
                    this.formData.org_city = selectedData[1].label;
                    this.formData.org_area = '';
                }
                else if(selectedData.length == 1) {
                    this.formData.org_city = '';
                    this.formData.org_area = '';
                }
            },
            submit: function(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        var url = "org/upd";
                        //url待接口确定后修改
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.alertSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    }  else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>
    .fix-height{
        height: 5px;
    }
    .f-logo{
        width: 200px;
        height: auto;
        border: 1px solid #dcdee2;
        border-radius: unset;
    }

    .sub-page-padding-right{
        padding-right: 100px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/org/info/info_save.vue